export default "__VITE_ASSET__Ox0JUnp0__"